module.exports = __webpack_public_path__ + "static/media/annaberg.21497c4b.png";